import { Link } from "react-router";
import { ArrowRight } from "lucide-react";
import { AnnouncementManager } from "./_components/announcement-manager";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

// Phase 7 sub-bucket 18 — landing page for /admin/settings. Two cards:
//   1. Announcements — strip shown on the partner portal dashboard
//   2. Invite team members — internal-user invite mint + copy URL
//
// Each card is a thin wrapper; the heavy lifting (form state, audience
// scoping chips, optimistic toggle) lives in the child components.

export function SettingsOverviewPage() {
  return (
    <div>
      <header className="mb-7">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
          Admin
        </p>
        <h1 className="mt-1 font-display text-3xl font-semibold tracking-tight">
          Settings
        </h1>
        <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
          Workspace-wide configuration.
        </p>
      </header>

      <div className="grid gap-6 lg:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle className="font-display tracking-tight">
              Announcements
            </CardTitle>
            <CardDescription>
              Strip shown on the partner portal dashboard. Use sparingly.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <AnnouncementManager />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="font-display tracking-tight">
              Users &amp; access
            </CardTitle>
            <CardDescription>
              Invite teammates, set their role, and manage account access for
              both staff and partner contacts.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Link
              to="/admin/users"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline"
            >
              Manage users
              <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="font-display tracking-tight">
              Connections &amp; API access
            </CardTitle>
            <CardDescription>
              Create personal access tokens to connect AI clients (e.g. Claude
              Code) to Colab over the Model Context Protocol.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Link
              to="/admin/settings/connections"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline"
            >
              Manage connections
              <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
